import React from 'react'
import { RouteProps } from '../../routes/AppRouter'
import { CreateTraining as C } from '../../features/training'
import { useTitleHeaderContext } from '../../common/utils/TitleHeaderContext'

export function CreateTraining(props: RouteProps) {
  const title = props.title || ''
  const { setTitle } = useTitleHeaderContext()

  setTitle(title)

  return <C id={props.id} />
}
